module.exports = __webpack_public_path__ + "img/pic_green.8594beed.png";